import React from "react";

const ProjectPage = () => {
  const videoId = "L5rtZH72v-Q";

  const credits = [
    { role: "Director / Cinematographer / Editor", name: "Sylvester P. Lukasiewicz, SPL Films LLC" },
    { role: "Sound Mixer", name: "Robert Kahn, Mixology Post LLC" },
    { role: "Color Correction & Grading", name: "Luis Otero, CSI, Digital Emulsion LLC" },
  ];

  return (
    // Removed the white background. 
    // Added 'text-white' so it inherits your global App.tsx dark gradient beautifully.
    <div className="max-w-5xl mx-auto px-8 py-12 md:py-16 text-white">
      
      {/* Header & Video Section - Two Columns on Desktop */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mb-8">
        
        {/* Left Column: Title & Metadata */}
        <div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6">
            Resilience and<br />Remembrance
          </h1>
          <div className="font-semibold text-sm leading-snug tracking-wide text-gray-300">
            <p>Documentary Short</p>
            <p>United States | 26 minutes</p>
            <p>English | English subtitles</p>
          </div>
        </div>

        {/* Right Column: Video Embed */}
        <div className="relative pb-[56.25%] h-0 shadow-2xl rounded overflow-hidden border border-gray-700 bg-black">
          <iframe
            className="absolute top-0 left-0 w-full h-full"
            src={`https://www.youtube.com/embed/${videoId}`}
            title="Resilience and Remembrance"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>

      {/* Top Divider - Changed to gray-500 to be visible on dark background */}
      <hr className="border-gray-500 border-t my-10" />

      {/* Synopsis */}
      <section className="space-y-6 text-lg text-gray-200">
        <p className="font-bold text-xl leading-relaxed text-white">
          A reflective, intimate documentary about a former Windows On The World employee as he returns to the rebuilt World Trade Center site and walks through memory.
        </p>
        <p>
          Through a single, unbroken conversational monologue, the narrator alternates between quiet reminiscence and the disorientation and panic of September 11, 2001: watching the towers smoke, racing home, and realizing how many colleagues never returned.
        </p>
        <p>
          As he moves through the 9/11 Memorial, Winter Garden, and the Oculus, he names coworkers, recalls small acts of kindness and shared jokes, and describes rituals—volleyball between shifts, framed keepsakes, funeral visits—that map a vanished community.
        </p>
        <p>
          The film juxtaposes lush present-day visuals of a beautifully rebuilt site with the palpable absence of those lost, exploring grief, memory, and the stubborn insistence on beauty and life after trauma.
        </p>
        <p className="italic text-gray-400">
          Ultimately it is a personal elegy and a testament to collective resilience and remembrance.
        </p>
      </section>

      {/* Bottom Divider */}
      <hr className="border-gray-500 border-t my-10" />

      {/* Credits */}
      <section>
        <h2 className="text-2xl font-extrabold tracking-widest mb-8 text-white">CREDITS</h2>
        <div className="space-y-6">
          {credits.map((credit, index) => (
            <div key={index}>
              <h3 className="font-bold text-lg text-white">{credit.role}</h3>
              <p className="text-md text-gray-300">{credit.name}</p>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
};

export { ProjectPage };